import { parseGymIdTyped, ParsedGymId } from '../lib/slugs';
import { Gym } from '../types';

/**
 * Extract gym identifier from route params or navigation state.
 * Supports:
 * 1. location.state.gym (direct pass-through — uses stableId if available, else placeId)
 * 2. URL slug with -gID suffix (SEO routes — distinguishes stableId vs legacy placeId)
 * 3. Direct ID param (Legacy routes)
 */
export function extractGymIdentifier(
    params: { gymSlugWithId?: string; gymId?: string },
    state?: { gym?: Gym }
): ParsedGymId | null {
    // 1. Prefer navigation state (optimization for instant render)
    if (state?.gym?.stableId) {
        return { id: state.gym.stableId, type: 'stable' };
    }
    if (state?.gym?.id) {
        return { id: state.gym.id, type: 'placeId' };
    }

    // 2. Try SEO slug param (e.g., /nsw/suburb/gyms/name-gxK9m2pLq)
    if (params.gymSlugWithId) {
        const parsed = parseGymIdTyped(params.gymSlugWithId);
        if (parsed && parsed.id.length > 5) return parsed;
    }

    // 3. Try direct legacy ID param (e.g., /:userId/gym/:gymId)
    if (params.gymId) {
        const isPlaceId = params.gymId.startsWith('ChIJ') && params.gymId.length > 20;
        return { id: params.gymId, type: isPlaceId ? 'placeId' : 'stable' };
    }

    return null;
}


